<template>
  <header class="header">
    <div class="container">
      <div class="header__wrapper">
        <div class="header__left">
          <router-link :to="translations.i18nRoute({ name: 'home' })" class="header__logo">
            <img src="@icons/logo.svg" alt="logo">
            <p>NEW GIFTS STORE</p>
          </router-link>
          <div class="header__left-line"></div>
          <ui-language-switcher />
          <el-scrollbar always>
            <nav class="header__nav">
  <!--            <router-link :to="translations.i18nRoute({ name: 'home' })">-->
  <!--              Gift Cards-->
  <!--            </router-link>-->
  <!--            <router-link :to="translations.i18nRoute({ name: 'home' })">-->
  <!--              Game cards-->
  <!--            </router-link>-->
              <router-link
                  v-for="category of categories"
                  :key="category.node.uuid"
                  :class="[{active: category.node.slug === route.query.category}]"
                  :to="translations.i18nRoute({ name: 'store', query: { category: category.node.slug } })"
              >
                {{ category.node.name }}
              </router-link>
  <!--            <router-link :to="translations.i18nRoute({ name: 'about' })">-->
  <!--              {{ t('header.about') }}-->
  <!--            </router-link>-->
  <!--            <router-link :to="translations.i18nRoute({ name: 'contact' })">-->
  <!--              {{ t('header.contact') }}-->
  <!--            </router-link>-->
            </nav>
          </el-scrollbar>
        </div>
        <div class="header__actions">
          <ui-profile-burger v-if="user" />
          <div class="header__actions-auth" v-else>
            <router-link :to="translations.i18nRoute({ name: 'login' })">{{ t('header.actions.login') }}</router-link>
            <div></div>
            <router-link :to="translations.i18nRoute({ name: 'register' })">{{ t('header.actions.register') }}</router-link>
          </div>
          <div class="header__actions-link" @click="redirect(user ? 'profile-wishlist' : 'login')">
            <div class="header__actions-counter">
              {{ productsInWishlistQuantity }}
            </div>
            <img src="@icons/wishlistIcon.svg" alt="wishlist">
          </div>
          <div class="header__actions-link" @click="redirect(user ? 'profile-cart' : 'login')">
            <div class="header__actions-counter">
              {{ productsInCartQuantity }}
            </div>
            <img src="@icons/cartIcon.svg" alt="cart">
          </div>
        </div>
        <svg class="header__menu" @click="isMenuActive = !isMenuActive" width="30px" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" fill="none">
          <path fill="#FF6162" fill-rule="evenodd"
              d="M18 5a1 1 0 100-2H2a1 1 0 000 2h16zm0 4a1 1 0 100-2h-8a1 1 0 100 2h8zm1 3a1 1 0 01-1 1H2a1 1 0 110-2h16a1 1 0 011 1zm-1 5a1 1 0 100-2h-8a1 1 0 100 2h8z"/>
        </svg>
      </div>
    </div>
    <div class="header__bottom">
      <form class="header__bottom-container container" @submit.prevent="searchQuery">
        <input
            type="text"
            class="header__bottom-input"
            :placeholder="t('fields.search')"
            v-model="searchInput"
        >
      </form>
    </div>
    <base-menu :isActive="isMenuActive" @close-modal="handleCloseModal" :categories="categories" />
  </header>
</template>

<script setup>
import translations from "@/core/helpers/translations.js";
import {useI18n} from "vue-i18n";
import {computed, onMounted, ref} from "vue";
import {useCartStore} from "@/stores/cart.js";
import {useWishlistStore} from "@/stores/wishlist.js";
import UiLanguageSwitcher from "@/components/ui/ui-language-switcher.vue";
import {useRoute, useRouter} from "vue-router";
import {useAuthStore} from "@/stores/auth.js";
import UiProfileBurger from "@/components/ui/ui-profile-burger.vue";
import BaseMenu from "@/components/base/base-menu.vue";
import {Categories} from "@/core/api/categories.js";

const router = useRouter()
const route = useRoute()
const {t} = useI18n()
const cartStore = useCartStore()
const wishlistStore = useWishlistStore()
const authStore = useAuthStore()

const user = computed(() => {
  return authStore.user ? authStore.user : null
})

const productsInCartQuantity = computed(() => {
  let count = 0
  cartStore.currentOrder.orderProducts?.edges.forEach((el) => {
    count = count + el.node.quantity
  })

  return count
})
const productsInWishlistQuantity = computed(() => {
  return wishlistStore.wishlist.products ? wishlistStore.wishlist.products.edges.length : 0
})

const isMenuActive = ref(false)
const handleCloseModal = () => {
  isMenuActive.value = false;
}

const searchInput = ref('')
const searchQuery = () => {
  router.push({
    name: "store",
    query: {
      name: searchInput.value
    },
    params: {
      locale: localStorage.getItem('ngs-user-locale') || 'en-gb'
    },
  });
}

const redirect = (routeName) => {
  router.push({
    name: routeName,
    params: {
      locale: localStorage.getItem('ngs-user-locale') || 'en-gb'
    }
  });
}

const categories = ref([])

onMounted(async () => {
  const res = await Categories.getCategories()
  categories.value = res.data.categories.edges
})
</script>

<style lang="scss" scoped>
.header {
  &__wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-block: 15px;
    gap: 25px;
  }

  &__left {
    display: flex;
    align-items: center;
    gap: 15px;

    &-line {
      background-color: #CDDAE7;
      width: 1px;
      height: 28px;
    }
  }

  &__logo {
    display: flex;
    align-items: center;
    gap: 10px;

    & p {
      flex-shrink: 0;
      color: #2F2F2F;
      font-size: 18px;
      font-weight: 700;
      line-height: 23.4px;
    }
  }

  &__nav {
    max-width: 850px;
    margin-left: 25px;
    display: flex;
    align-items: center;
    gap: 20px;

    & a {
      flex-shrink: 0;
      transition: 0.2s;
      color: #5A5A5A;
      font-size: 16px;
      font-weight: 400;
      line-height: 19.2px;

      &.active {
        color: #FF6162;
      }

      @include hover {
        color: #FF6162;
      }
    }
  }

  &__actions {
    display: flex;
    align-items: center;
    gap: 15px;
    flex-shrink: 0;

    &-auth {
      display: flex;
      align-items: center;
      gap: 10px;
      flex-shrink: 0;

      & div {
        background-color: #8C8C8C;
        width: 1px;
        height: 28px;
      }

      & a {
        flex-shrink: 0;
        transition: 0.2s;
        color: #8C8C8C;
        font-size: 16px;
        font-weight: 400;
        line-height: 16px;

        @include hover {
          color: #FF6162;
        }
      }
    }

    &-link {
      cursor: pointer;
      position: relative;
    }

    &-counter {
      position: absolute;
      top: -10px;
      right: -10px;
      border-radius: 50%;
      background-color: #FF6162;
      width: 20px;
      height: 20px;
      display: grid;
      place-items: center;

      color: $white;
      text-align: center;
      font-size: 10px;
      font-weight: 400;
      line-height: 15px;
    }
  }

  &__bottom {
    background: linear-gradient(90deg, #FF6162 0%, #EB5393 93.44%, #F4915D 100%);
    padding-block: 7px;

    &-container {
      display: grid;
      place-items: center;
    }

    &-input {
      width: 90%;
      margin-inline: auto;
      background-image: url(@icons/searchIcon.svg);
      background-repeat: no-repeat;
      background-position: center right 20px;
      padding: 12px 16px;
      border-radius: 52px;
      border: 1px solid #E8E8E8;
      background-color: $white;

      color: #777;
      font-size: 15px;
      font-weight: 400;
    }
  }

  &__menu {
    cursor: pointer;
    display: none;
  }
}

:deep(.el-scrollbar) {
  overflow: unset !important;
}
:deep(.el-scrollbar__bar.is-horizontal) {
  height: 4px !important;
  bottom: -10px !important;
}
:deep(.el-scrollbar__thumb) {
  background-color: #FF6162 !important;
  opacity: 20% !important;
}

@media (max-width: 1680px) {
  .header {
    &__nav {
      max-width: 650px;
    }
  }
}

@media (max-width: 1100px) {
  .header {
    &__nav, &__actions {
      display: none;
    }

    &__menu {
      display: block;
    }
  }
}

@media (max-width: 450px) {
  .header {
    &__logo {
      & p {
        font-size: 14px;
      }
    }

    &__bottom-input {
      width: 100%;
    }
  }
}
</style>